import { graphqlFetch } from '@/utils/graphqlFetch';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { GetExams } from '../queries';
import { ExamFilteredOutput, ExamInput, ExamOutput, ExamQuery } from '../gql/graphql';
import { CREATE_EXAM } from '../mutations';

export const useGetExams = (query: ExamQuery) => {
  return useQuery<ExamFilteredOutput[], Error>({
    queryKey: ['exams', query],
    queryFn: async () => {
      const { getExams } = await graphqlFetch<
        { getExams: ExamFilteredOutput[] },
        { query: ExamQuery }
      >(GetExams, { query });
      return getExams;
    },
  });
};

export const useCreateExam = () => {
  const queryClient = useQueryClient();
  return useMutation<ExamOutput, Error, ExamInput>({
    mutationFn: async (input) => {
      const { createExam } = await graphqlFetch<
        { createExam: ExamOutput },
        { input: ExamInput }
      >(CREATE_EXAM, { input });
      return createExam;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['exams'] });
    },
  });
};
